import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Badge, type PortalDashboardEnrollment } from "@dearbill/shared";
import { m3pBadge } from "../m3pStatusBadge";
import { HomeCard } from "./HomeCard";

/** The member's M3P program row, badged by `m3pBadge`. */
export function ProgramsCard({
  enrollment,
}: {
  enrollment: PortalDashboardEnrollment | null;
}): ReactNode {
  const { label, tone } = m3pBadge(enrollment);
  return (
    <HomeCard
      title="Your Active Programs"
      titleSize="lg"
      action={
        <Link
          to="/programs"
          className="text-link text-primary-text hover:text-ember-dark shrink-0 hover:underline"
        >
          See all
        </Link>
      }
    >
      <ul>
        <li className="flex items-center justify-between gap-4">
          <span className="text-body-sm text-midnight min-w-0 font-semibold">
            Medicare Prescription Payment Plan (M3P)
          </span>
          <Badge tone={tone} className="shrink-0">
            {label}
          </Badge>
        </li>
      </ul>
    </HomeCard>
  );
}
